import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export const Route = createFileRoute("/kontakt")({
  head: () => ({
    meta: [
      { title: "Kontakt — ARTBAZ | Stavebná firma Trenčín" },
      {
        name: "description",
        content:
          "Kontaktujte ARTBAZ — nezáväzná cenová ponuka na rekonštrukcie, stavby a interiéry. Telefón, email a adresa stavebnej firmy v Trenčíne.",
      },
      { property: "og:title", content: "Kontakt — ARTBAZ" },
      {
        property: "og:description",
        content:
          "Máte otázku alebo plánujete rekonštrukciu? Napíšte nám alebo zavolajte — radi pripravíme cenovú ponuku.",
      },
    ],
  }),
  component: KontaktPage,
});

function KontaktPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-28">
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
